import React from 'react';
import { usePaperEvaluationChat } from '../hooks/usePaperEvaluationChat';
import { WorkData } from '../types';
import ChatInterface from './ChatInterface';

type PaperEvaluationChatProps = {
  work: WorkData;
};

export const PaperEvaluationChat: React.FC<PaperEvaluationChatProps> = ({
  work,
}) => {
  const { messages, loading, error, clearError, resetChat, sendMessage } =
    usePaperEvaluationChat(work);
  return (
    <ChatInterface
      messages={messages.map((message, index) => ({
        id: index.toString(),
        content: message.content,
        role: message.role,
      }))}
      title="Chat with a paper"
      onSendMessage={sendMessage}
      isLoading={loading}
      error={error}
      onClearError={clearError}
      onClearChat={resetChat}
      placeholder="Ask about this paper's citations, methodology, or findings..."
    />
  );
};
